/**
 * Advancers / decliners breadth (F5, plan §3.3).
 *
 * "Advancing" is STRICTLY positive, matching the demo's `ret > 0` — a flat
 * return is not an advance. A null return is excluded from both counts rather
 * than lumped into decliners: an unreported return is not a decline, and
 * counting it as one would make breadth deteriorate every time coverage does.
 * `advancers + decliners <= rows.length` is therefore the invariant, not
 * equality.
 */
import type { Breadth, WindowKey } from '@meridian/contracts';

export interface BreadthInput {
  readonly ret: Readonly<Record<WindowKey, number | null>>;
}

export function computeBreadth(rows: readonly BreadthInput[], window: WindowKey): Breadth {
  const observed = rows.map((r) => r.ret[window]).filter((r): r is number => r !== null);
  const advancers = observed.filter((r) => r > 0).length;
  const decliners = observed.length - advancers;
  return {
    advancers,
    decliners,
    ratio: observed.length === 0 ? 0 : advancers / observed.length,
  };
}
